import {
  getAllProductsByStyle,
  getProductTags,
  setAttributes,
} from '../helpers/productStyles';

import { validateEmail, buildSizes, buildTable } from '../helpers/util';

export default class ProductKits {
  constructor(productEl) {
    this.el = productEl;
    this.dataEl = this.el.querySelector('[data-product-kit]');
    this.data = JSON.parse(this.dataEl.innerHTML);
    this.swatchesType = this.el.querySelector(
      '[data-swatches-type]',
    )?.dataset?.swatchesType;

    this.init();
  }

  init = async () => {
    if (!this.el) return;

    const styleTag = getProductTags(this.data, 'style');
    if (styleTag.length) {
      this.allProductStyles = await getAllProductsByStyle(styleTag);
    } else {
      this.allProductStyles = false;
    }
    this.badgeTags = getProductTags(this.data, 'badge');
    this.benefitTags = getProductTags(this.data, 'benefits');
  };

  buildBadge = (tags = []) => {
    const badgesInfo = JSON.parse(
      document.querySelector('[data-badge-data]').innerHTML,
    );
    let badgeReturn;
    if (tags != []) {
      tags.forEach((tag) => {
        let singleBadgeInfo = badgesInfo.badges.filter(function (badge) {
          return badge.badgeTag == tag;
        })[0];
        if (singleBadgeInfo != undefined) {
          let singleBadgeWrap = document.createElement('div');
          singleBadgeWrap.classList.add(
            'badge__single',
            singleBadgeInfo.badgePosition,
          );
          singleBadgeWrap.style.backgroundColor = singleBadgeInfo.badgeColor;
          if (singleBadgeInfo.badgeText != '') {
            let singleBadgeText = document.createElement('span');
            singleBadgeText.style.color = singleBadgeInfo.badgeTextColor;
            if (singleBadgeInfo.badgeTextLine != '1') {
              singleBadgeInfo.badgeText = singleBadgeInfo.badgeText.replace(
                ' ',
                '<br/>',
              );
              singleBadgeWrap.classList.add('badge__single--lines');
            }
            singleBadgeText.innerHTML = singleBadgeInfo.badgeText;
            singleBadgeWrap.appendChild(singleBadgeText);
          }
          if (!badgeReturn) {
            badgeReturn = singleBadgeWrap;
          }
        }
      });
      return badgeReturn;
    }
  };

  buildBenefits = (tags = [], type) => {
    const benefitsStack = document.querySelectorAll('[data-benefits-data]');
    if (tags != []) {
      let benefitsReturn = [];
      benefitsStack.forEach((benefitSingle) => {
        let benefitsInfo = JSON.parse(benefitSingle.innerHTML);
        tags.forEach((tag) => {
          let singleBenefitInfo = benefitsInfo.benefits.filter(function (
            benefit,
          ) {
            return benefit.benefitId == tag;
          })[0];
          if (singleBenefitInfo != undefined) {
            let singleBenefitWrap = document.createElement('figure');
            singleBenefitWrap.classList.add(`${type}__benefits--item`);
            if (singleBenefitInfo.benefitImage != null) {
              let singleBenefitImageWrap = document.createElement('span');
              singleBenefitImageWrap.classList.add(`${type}__benefits--ico`);
              let singleBenefitImage = document.createElement('img');
              setAttributes(singleBenefitImage, {
                src: singleBenefitInfo.benefitImage,
                alt: '',
                srcset: this.buildSrcSet(singleBenefitInfo.benefitImage),
              });
              singleBenefitImageWrap.prepend(singleBenefitImage);
              singleBenefitWrap.prepend(singleBenefitImageWrap);
            }
            if (singleBenefitInfo.benefitTitle != '') {
              let singleBenefitText = document.createElement('figcaption');
              singleBenefitText.innerHTML = singleBenefitInfo.benefitTitle;
              singleBenefitWrap.appendChild(singleBenefitText);
            }
            benefitsReturn.push(singleBenefitWrap);
          }
        });
      });
      return benefitsReturn;
    }
  };

  buildMoreItem = function (product) {
    let aDesktop = document.createElement('a');
    let aMobile = document.createElement('a');
    let desktopMaxSwatches = 7; // max
    let mobileMaxSwatches = 3;

    product.div.classList.add(
      'product-card__swatches--item',
      'product-card__swatches--more',
    );

    aDesktop.classList.add('swatches-count-desktop');
    setAttributes(aDesktop, {
      href: product.url,
      'data-product-link': '',
    });

    if (product.moreItem - desktopMaxSwatches > 0) {
      aDesktop.textContent = '+' + (product.moreItem - 7);
    }

    aMobile.classList.add('swatches-count-mobile');
    setAttributes(aMobile, {
      href: product.url,
      'data-product-link': '',
    });

    if (product.moreItem - mobileMaxSwatches > 0) {
      aMobile.textContent = '+' + (product.moreItem - 3);
    }

    product.div.appendChild(aDesktop);
    product.div.appendChild(aMobile);
    return product.div;
  };

  buildSwatchItem = (product = {}, moreItem = 0) => {
    product.div = document.createElement('div');
    product.moreItem = moreItem;
    if (moreItem != 0) {
      return this.buildMoreItem(product);
    }
    setAttributes(product.div, {
      'data-product-id': product?.id,
      'data-product-swatch': '',
      'data-color-name': product.selectedColor,
    });
    !product?.available ? product.div.classList.add('disabled') : null;
    if (
      this.el.classList.contains('product-card') ||
      this.swatchesType == 'color'
    ) {
      let span = document.createElement('span');
      product.div.classList.add('product-card__swatches--item');
      span.classList.add('swatch-color');
      if (product.swatchHexcode1 != null && product.swatchHexcode1 != '') {
        span.style.backgroundColor = product.swatchHexcode1;
      } else {
        span.style.backgroundColor = '#ffffff';
      }
      if (product.swatchHexcode2 != null && product.swatchHexcode2 != '') {
        let spanAlternative = document.createElement('span');
        spanAlternative.classList.add('swatch-color--alternative');
        spanAlternative.style.backgroundColor = product.swatchHexcode2;
        product.div.appendChild(spanAlternative);
      }
      if (product.swatchImgUrl != null && product.swatchImgUrl != '') {
        span.classList.add('swatch-color--image');
        let image = document.createElement('img');
        setAttributes(image, {
          src: product.swatchImgUrl,
          alt: '',
          srcset: this.buildSrcSet(product.swatchImgUrl),
        });
        span.appendChild(image);
      }
      product.div.appendChild(span);
    } else {
      let imageWrap = document.createElement('div');
      let videos = '';
      let imagesWithIndex = '';
      product.div.classList.add('variants__color--item');
      product.media.forEach((media) => {
        if (imagesWithIndex == '') {
          imagesWithIndex += `${media.src}*${media.position}`;
        } else {
          imagesWithIndex += `,${media.src}*${media.position}`;
        }
        if (media.media_type != 'image') {
          let videoItem = '';
          if (media.media_type == 'video') {
            videoItem = `${media.sources[0].url}~video`;
          } else {
            videoItem = `${media.external_id}~${media.host}`;
          }
          if (videos == '') {
            videos += videoItem;
          } else {
            videos += `|${videoItem}`;
          }
        }
      });
      imageWrap.classList.add('variants__color--item__image-wrap');
      if (product?.imageThumb != null && product?.imageThumb != '') {
        imageWrap.classList.add('swatch-color--image');
        let image = document.createElement('img');
        setAttributes(image, {
          src: product?.imageThumb,
          alt: '',
          srcset: this.buildSrcSet(product?.imageThumb),
        });
        imageWrap.appendChild(image);
      }
      product.div.appendChild(imageWrap);
    }
    return product.div;
  };

  updatePrice = (variant) => {
    this.el.querySelectorAll('[data-product-price]').forEach((priceItem) => {
      priceItem.textContent = variant.formattedPrice;
      if (
        !variant.formattedCompareAtPrice ||
        variant.formattedCompareAtPrice == variant.formattedPrice
      ) {
        priceItem.classList.remove('sale-price');
      } else if (variant.formattedCompareAtPrice != variant.formattedPrice) {
        priceItem.classList.add('sale-price');
      }
    });
  };

  updateCompareAtPrice = (variant) => {
    let comparePrice = variant.formattedCompareAtPrice
      ? variant.formattedCompareAtPrice
      : '';
    if (variant.formattedCompareAtPrice != variant.formattedPrice) {
      this.el
        .querySelectorAll('[data-product-compare]')
        .forEach((priceItem) => {
          priceItem.textContent = comparePrice;
        });
    } else {
      this.el
        .querySelectorAll('[data-product-compare]')
        .forEach((priceItem) => {
          priceItem.textContent = '';
        });
    }
  };

  updateKlarna = (variant) => {
    const klarnaEls = document.getElementsByTagName('klarna-placement');
    if (!variant && !klarnaEls) return;
    if (klarnaEls.length) {
      klarnaEls.forEach((el) => {
        el.setAttribute('data-purchase-amount', variant.price);
      });
      window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
      window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
    }
  };

  buildKitItemSelected = (product = {}, type = '', kitContainer) => {
    if (kitContainer.querySelector(`.${type}__kit-item--wrap`) != null) {
      kitContainer.querySelector(`.${type}__kit-item--wrap`).remove();
    }
    let kitItemSelectedWrap = document.createElement('div');
    kitItemSelectedWrap.classList.add(`${type}__kit-item--wrap`);
    kitItemSelectedWrap.innerHTML = `<div class="${type}__kit-item--selected">
      <div class="${type}__kit-item--image">
        <a target="_blank" href="${product.url}">
          <img src="${product.imageThumb}" alt=""/>
        </a>
      </div>
      <div class="${type}__kit-item--content">
        <div class="${type}__kit-item--title">
          <a target="_blank" href="${product.url}">${product.title}</a>
        </div>
        <div class="${type}__kit-item--type">
          <p>${product.type}</p>
        </div>
        <div class="${type}__kit-item--view">
          <a target="_blank" href="${product.url}">View Details</a>
        </div>
      </div>
    </div>`;
    kitContainer.prepend(kitItemSelectedWrap);
  };

  buildOtherSwatches = (product = {}, type = '', kitContainer) => {
    let addKitButton = document.querySelector('[data-product-add-kit]');
    product.optionsWithValues.forEach((option) => {
      let optionLower = option.name.toLowerCase();
      if (optionLower != 'color') {
        let sizeListNode = kitContainer.querySelector(
          `[data-option-name='${optionLower}'] .variants__size--list`,
        );
        if (sizeListNode) {
          sizeListNode.innerHTML = '';
          let sizeContainerNode = kitContainer.querySelector(
            `[data-option-name='${optionLower}']`,
          );
          let backInStockForm = this.el.querySelector(
            `.${type}__back-in-stock`,
          );
          let backInStockFormButton = this.el.querySelector(
            `.${type}__back-in-stock-form-button`,
          );
          let formWrapButton = this.el.querySelector(
            `.${type}__form--wrap button[data-product-add]`,
          );
          sizeContainerNode.style.display = 'none';
          let isFirstValue = true;
          let displayedOptions = [];
          option.values.forEach((value, index) => {
            let otherSwatch = document.createElement('div');
            otherSwatch.classList.add('variants__size--item');
            if (
              isFirstValue &&
              product.selectedOrFirstAvailableVariant.options.includes(value)
            ) {
              otherSwatch.classList.add('selected');
              isFirstValue = false;
              let comparePriceAttribute = product
                .selectedOrFirstAvailableVariant.compare_at_price
                ? product.selectedOrFirstAvailableVariant.compare_at_price
                : '';
              setAttributes(kitContainer, {
                'data-selected-kit-variant':
                  product.selectedOrFirstAvailableVariant.id,
                'data-compare-price-item': comparePriceAttribute,
                'data-price-item':
                  product.selectedOrFirstAvailableVariant.price,
              });
            }
            setAttributes(otherSwatch, {
              'data-variant-option-value': value,
              'data-variant-option-index': `option${option.position}`,
              'data-variant-available': product.variants[index].available,
            });
            let otherSwatchSpan = document.createElement('span');
            otherSwatchSpan.textContent = value;
            otherSwatch.appendChild(otherSwatchSpan);
            if (!displayedOptions.includes(value)) {
              sizeListNode.appendChild(otherSwatch);
              otherSwatch.addEventListener('click', (e) => {
                if (e.currentTarget.classList.contains('selected')) {
                  return false;
                }
                let choosedVariant = product.variants.filter((variant) => {
                  return variant.options.includes(value);
                });
                let selectedSwatchNode = kitContainer.querySelector(
                  `[data-option-name='${optionLower}'] .variants__size--list .variants__size--item.selected`,
                );
                let selectedSwatchNodeGuide = kitContainer.querySelector(
                  '.size-guide-table .selected',
                );
                if (selectedSwatchNode) {
                  selectedSwatchNode.classList.remove('selected');
                }
                if (product.size_guide_cta_enabled && selectedSwatchNodeGuide) {
                  selectedSwatchNodeGuide.classList.remove('selected');
                  kitContainer
                    .querySelector(
                      `.size-guide-table .add-size[data-variant-option-value="${value}"]`,
                    )
                    .parentNode.classList.add('selected');
                }
                e.currentTarget.classList.add('selected');
                if (choosedVariant[0].available == false) {
                  if (addKitButton) {
                    addKitButton.removeAttribute('data-product-add-kit');
                    addKitButton.removeAttribute('data-drawer-trigger');
                    addKitButton.textContent = 'Not Available';
                  }
                } else {
                  if (addKitButton) {
                    addKitButton.setAttribute('data-product-add-kit', '');
                    addKitButton.setAttribute('data-drawer-trigger', '');
                    addKitButton.textContent = 'Add to Cart';
                  }
                  let comparePriceAttribute = choosedVariant[0].compareAtPrice
                    ? choosedVariant[0].compareAtPrice
                    : '';
                  setAttributes(kitContainer, {
                    'data-selected-kit-variant': choosedVariant[0].id,
                    'data-compare-price-item': comparePriceAttribute,
                    'data-price-item': choosedVariant[0].price,
                  });
                }
              });
              displayedOptions.push(value);
            }
          });
          if (displayedOptions.length > 1) {
            sizeContainerNode.style.display = 'block';
            const sizeGuide = product.tags.filter((element) => {
              element.includes('size_guide');
            });
            if (sizeGuide.length) {
              let guideToggle = document.createElement('div');
              guideToggle.classList.add('size-guide-toggle');
              guideToggle.dataset.guideId = product.id;
              guideToggle.innerHTML = '<p>Size Guide</p>';
              sizeListNode.after(guideToggle);
            }
          }
        }
      }
    });
  };

  buildSrcSet = (image) => {
    let RangeWidths = [165, 360, 533, 720, 940, 1066];
    let dataSrcSet = '';
    for (var i = 0; i < RangeWidths.length; i++) {
      dataSrcSet += image + ' ' + RangeWidths[i] + 'w';
      if (i < RangeWidths.length - 1) {
        dataSrcSet += ', ';
      }
    }
    return dataSrcSet;
  };

  BISInit = (type) => {
    let formButton = this.el.querySelector(
      `.${type}__back-in-stock-form-button`,
    );
    formButton.addEventListener('click', (e) => {
      let email = this.el.querySelector(
          `.${type}__back-in-stock-form-email`,
        ).value,
        productId = this.el.querySelector('[data-variant-productid]').dataset
          .variantProductid,
        variantId = this.el.querySelector('[data-bis-variant-id]').dataset
          .bisVariantId;
      if (validateEmail(email)) {
        window.BIS.create(email, variantId, productId, {
          accepts_marketing: true,
        });
        this.el
          .querySelector(`.${type}__back-in-stock`)
          .classList.add('success');
        this.el
          .querySelector(`.${type}__back-in-stock-form-email`)
          .classList?.remove('invalid');
        this.el
          .querySelector(`.${type}__back-in-stock`)
          .classList.remove('error');
      } else {
        this.el
          .querySelector(`.${type}__back-in-stock-form-email`)
          .classList?.add('invalid');
        this.el.querySelector(`.${type}__back-in-stock`).classList.add('error');
        this.el
          .querySelector(`.${type}__back-in-stock`)
          .classList.remove('success');
      }
    });
  };
}
